module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "plottable-chart detail-table"
  }, [(!_vm.isDataLoaded) ? _c('loader', {
    staticClass: "panel-loader"
  }) : _vm._e(), _vm._v(" "), (_vm.isDataLoaded && !_vm.hasError) ? _c('div', {
    staticClass: "chart-container"
  }, [_c('div', {
    staticClass: "chart-controls"
  }, [_c('div', {
    staticClass: "breadcrumb-container"
  }, [(_vm.dataZoom.length || _vm.detailView) ? _c('ul', {
    staticClass: "breadcrumb"
  }, [_c('li', {
    staticClass: "clickable",
    on: {
      "click": function($event) {
        _vm.dataZoomReset()
      }
    }
  }, [_vm._v("Top")]), _vm._v(" "), _vm._l((_vm.dataZoom), function(zoom, index) {
    return _c('li', {
      class: _vm.breadcrumbClickable(index),
      on: {
        "click": function($event) {
          _vm.breadcrumbZoomOut(index)
        }
      }
    }, [_vm._v(_vm._s(_vm.parentLabel(zoom)))])
  }), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.detailView),
      expression: "detailView"
    }],
    staticClass: "clickable",
    on: {
      "click": function($event) {
        _vm.hideDetails()
      }
    }
  }, [_vm._v("Back")])], 2) : _vm._e()]), _vm._v(" "), (_vm.hasFilter) ? _c('div', {
    staticClass: "filter"
  }, [_vm._l((_vm.filter), function(filterValue, filterName) {
    return [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.filter[filterName]),
        expression: "filter[filterName]"
      }],
      staticClass: "form-control",
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(_vm.filter, filterName, $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          _vm.getData()
        }]
      }
    }, _vm._l((_vm.filterOptions[filterName]), function(filterOption) {
      return _c('option', {
        domProps: {
          "value": filterOption.value
        }
      }, [_vm._v(_vm._s(filterOption.label))])
    }))]
  })], 2) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.detailView),
      expression: "!detailView"
    }],
    staticClass: "table-data"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', _vm._l((_vm.content['tableMetaData']), function(field) {
    return _c('th', [_vm._v(_vm._s(field.label || field))])
  }))]), _vm._v(" "), _c('tbody', _vm._l((_vm.filteredTableData()), function(row, index) {
    return _c('tr', {
      staticClass: "clickable",
      on: {
        "click": function($event) {
          _vm.zoomIn(row['id'], index)
        }
      }
    }, _vm._l((_vm.trimRow(row, _vm.content['tableMetaData'])), function(field) {
      return _c('td', [_vm._v(_vm._s(field))])
    }))
  }))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.detailView),
      expression: "detailView"
    }],
    staticClass: "detailed-data"
  }, [_c('h4', [_vm._v(_vm._s(_vm.implode(_vm.detailLabel, ', ')))]), _vm._v(" "), _c('dl', [_vm._l((_vm.content['detailMetaData']), function(field, index) {
    return [_c('dt', [_vm._v(_vm._s(field.label || field))]), _vm._v(" "), _vm._l((_vm.getDetailField(index, field.format || index)), function(value) {
      return _c('dd', [(_vm.hasDetailFieldLink(field)) ? [_c('a', {
        attrs: {
          "href": _vm.getDetailFieldLink(field)
        }
      }, [_vm._v(_vm._s(value))])] : _vm._e(), _vm._v(" "), (!_vm.hasDetailFieldLink(field)) ? [_vm._v("\n                            " + _vm._s(value) + "\n                        ")] : _vm._e()], 2)
    })]
  })], 2)])]) : _vm._e(), _vm._v(" "), (_vm.isDataLoaded && _vm.hasError) ? _c('div', {
    staticClass: "error-container alert alert-danger"
  }, [_vm._v("\n        " + _vm._s(_vm.error) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.isDataLoaded && _vm.hasGenDate) ? _c('div', {
    staticClass: "chart-generation-date"
  }, [_vm._v("\n         Data generated at: " + _vm._s(_vm.content['genDate']) + "\n    ")]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e7206dc2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/charts/DetailTable.vue
// module id = 1124
// module chunks = 0